import { useTranslation } from "react-i18next";
import { toAppUrl } from "src/services/configService";
import { makeStyles } from "tss-react/mui";

import { Box, Typography } from "@mui/material";
import { PrimaryButton } from "@shared/CustomButton";
import technicalProblemsImage from "@shared/images/robot-technical.webp";

const useStyles = makeStyles()((theme) => ({
    wrapper: {
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        padding: theme.spacing(4),
        backgroundColor: theme.palette.emteria.background.paper,
    },
    centerAnchor: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
    },
    characterWrapper: {
        position: "absolute",
        left: "50%",
        bottom: "100%",
        transform: "translateX(-50%)",
        marginBottom: theme.spacing(4),
    },
    character: {
        width: 600,
        height: 300,
        objectFit: "contain",
        filter: "drop-shadow(0 8px 24px rgba(46, 74, 110, 0.15))",
        [theme.breakpoints.down("sm")]: {
            width: 360,
            height: 450,
        },
    },
    textBlock: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: theme.spacing(3),
    },
    refreshButton: {
        marginTop: theme.spacing(3),
    },
    title: {
        fontWeight: 700,
        color: theme.palette.emteria.text.primary,
    },
    message: {
        maxWidth: 600,
        color: theme.palette.emteria.text.secondary,
        lineHeight: 1.6,
    },
}));

export const TechnicalDifficultiesPage = () => {
    const { classes } = useStyles();
    const { t } = useTranslation(["common"]);

    const onRefresh = () => {
        window.location.href = toAppUrl("/dashboard");
    };

    return (
        <Box className={classes.wrapper}>
            <Box className={classes.centerAnchor}>
                <Box className={classes.characterWrapper}>
                    <Box component="img" src={technicalProblemsImage} alt="" className={classes.character} />
                </Box>
                <Box className={classes.textBlock}>
                    <Typography variant="h5" component="h1" className={classes.title}>
                        {t("common:error.technicalDifficulties.title")}
                    </Typography>
                    <Typography variant="body1" className={classes.message}>
                        {t("common:error.technicalDifficulties.message")}
                    </Typography>
                    <PrimaryButton
                        className={classes.refreshButton}
                        endIcon={<i className="fa-solid fa-rotate-right" />}
                        onClick={onRefresh}
                    >
                        {t("common:error.technicalDifficulties.refreshButton")}
                    </PrimaryButton>
                </Box>
            </Box>
        </Box>
    );
};
